import { KalturaDoubleValue, KalturaStringValue } from '@kaltura-ott/ott-client-types/api/types';

export const metaTypeMap = {
  NUMBER: KalturaDoubleValue,
  STRING: KalturaStringValue,
};
